import { IsIn } from 'class-validator';

export class ParallelGroupDto {
  @IsIn(['ParallelGroup'])
  type: 'ParallelGroup';

  @IsIn(['true', 'false'])
  joinAny: 'true' | 'false';
}
